module.exports = __webpack_public_path__ + "static/media/logo-flower.6cdab329.jpg";